import '@polymer/polymer/lib/elements/custom-style.js';
import '@polymer/polymer/lib/elements/dom-module.js';
import { darkColors } from './darkColors';
import { highContrast } from './highContrast';

const $_documentContainer = document.createElement('custom-style');

$_documentContainer.setAttribute('id', 'nirvana-ds-colors');

$_documentContainer.innerHTML = `
  <style>
    html {

      --white-layout-300-primary: #FFFFFF;
      --white-layout-301-level-0-elevation: #FFFFFF;
      --white-layout-302-level-1-elevation: #FFFFFF;
      --white-layout-303-level-2-elevation: #FFFFFF;
      --white-layout-304-text: #FFFFFF;
      --white-layout-305-disabled-text: #FFFFFF;
      --white-layout-306-primary-hc: #FFFFFF;
      --white-layout-200-secondary: #ffffffe6;
      --white-layout-302-active-focus: #fff0;
      --white-layout-201-secondary-on-dark-background: #ffffffe6;
      --white-layout-250-disabled-text-on-blue-background: #ffffff99;
      --white-layout-100-disabled: #ffffffe6;
      --white-layout-101-outline-on-dark-background: #ffffff4d;
      --white-layout-050-hover-on-dark-background: #ffffff26;
      --white-layout-010-hover-primary: #ffffff1f;
      --white-layout-011-hover-on-blue-background: #ffffff1f;
      --white-layout-012-hover-on-blue-background: #ffffff1f;
      --white-layout-005-background-for-icon-menu: #ffffff0d;
      --white-layout-001-hover-on-blue-background: #fff0;
      --white-layout-002-light-background-on-dark-theme: #fff0;

      --grey-layout-020-side-panel-background: #F9F9F9;
      --grey-layout-500-neutral-background: #3C3C3C;
      --grey-layout-501-neutral-background: #3C3C3C;
      --black-layout-700-primary: #000000;
      --black-layout-701-primary: #000000;

      --main-titles-inputs-600: #000000e6;
      --main-titles-inputs-601: #000000e6;
      --main-titles-inputs-602: #000000e6;
      --main-titles-inputs-603: #000000e6;

      --body-text-arrows-400: #000000b3;
      --body-text-arrows-401: #000000b3;

      --chart-300-icon-buttons: #00000080;
      --chart-301-icon-buttons: #00000080;
      --chart-302-icon-buttons-titles: #00000080;
      --chart-303-icon-buttons-titles: #00000080;
      --chart-304-icon-buttons: #00000080;
      --chart-305-icon-buttons: #00000080;

      --grey-layout-200-disabled: #0000004c;
      --grey-layout-201-disabled-text: #0000004c;
      --grey-layout-202-disabled-icons: #0000004c;
      --grey-layout-203-dark-theme-disabled-text: #0000004c;

      --chart-100-pressed: #0000001f;
      --chart-101-pressed-dividers: #0000001f;
      --chart-102-pressed: #0000001f;
      --chart-103-pressed: #0000001f;
      --chart-104-pressed: #0000001f;
      --chart-105-solid: #C2C2C2;

      --chart-050-hover: #0000000d;
      --chart-051-hover: #0000000d;
      --chart-052-graph-background: #0000000d;

      --blue-layout-500-focus: #065CC1;
      --blue-layout-501-focus: #065CC1;
      --blue-layout-502-focus: #fff0;
      --blue-layout-503-focus-on-dark-background-hc: #065CC1;
      --blue-layout-504-focus-on-dark-background-light-theme: #B3D3FF;

      --blue-layout-400-primary: #006DFF;
      --blue-layout-401-primary: #006DFF;
      --blue-layout-402-primary-background: #006DFF;
      --blue-layout-403-primary: #006DFF;
      --blue-layout-404-primary: #006DFF;
      --blue-layout-405-primary-hc-on-light-background: #006DFF;

      --blue-layout-300-active: #2485D9;
      --blue-layout-301-active: #2485D9;
      --blue-layout-302-active-focus: #fff0;
      --blue-layout-303-active: #2485D9;
      --blue-layout-304-active: #2485D9;
      --blue-layout-305-active: #349DF726;
      --blue-layout-306-active: #8CCAFF;
      --blue-layout-307-active-hc: #2485D9;
      --blue-layout-308-active-hc: #2485D9;

      --blue-layout-200-disabled: #006eff4d;
      --blue-layout-201-disabled: #006eff4d;
      --blue-layout-202-disabled: #006eff4d;
      --blue-layout-203-disabled: #006eff4d;

      --blue-layout-100-background: #006eff26;
      --blue-layout-101-background: #D9E9FF;
      --blue-layout-102-background: #006eff26;
      --blue-layout-103-background: #006eff26;
      --blue-layout-104-solid-background: #D9E9FF;

      --blue-layout-050-selected: #006eff0d;
      --blue-layout-051-selected: #006eff0d;

      --dark-blue-700-main-menu: #090E13;
      --dark-blue-701-main-menu-dark-background: #161E29;
      --dark-blue-702-main-menu: #20252B;
      --dark-blue-703-main-menu: #161E29;

      --dark-blue-600-secondary-menu: #202C3D;

      --red-layout-001-logo: #FF0000;
      --red-layout-300-primary: #DB2A33;
      --red-layout-301-primary: #DB2A33;
      --red-layout-302-primary: #DB2A33;
      --red-layout-303-primary: #DB2A33;
      --red-layout-200-hover: #db2a3399;
      --red-layout-201-hover: #db2a3399;
      --red-layout-100-disabled: #db29324d;
      --red-layout-101-disabled: #db29324d;
      --red-layout-102-disabled: #db29324d;
      --red-layout-050-background: #db29320d;
      --red-layout-051-background: #db29320d;

      --green-layout-100-primary-green: #1F8463;
      --green-layout-101-primary-green: #1F8463;
      --green-layout-102-primary-green-hc: #1F8463;
      --green-layout-050-secondary-green: #1f8462b3;

      --orange-layout-050-warning: #ffa438;
      --yellow-layout-200-text-highlight: #FFD600;
      --red-alert-chart-700-critical: #922227;
      --red-alert-500-severe: #E90A0A;
      --orange-alert-chart-100: #FF883F;
      --yellow-alert-050: #FFD600;
      --green-pastel-alert-chart-050-healty: #A2D179;

      --gradient-400-main-blue: #C1D0EA;
      --gradient-401-main-blue: #C1D0EA;

      --gradient-300-light-main-blue: #C5D3EC;
      --gradient-301-light-main-blue: #C5D3EC;

      --gradient-200-secondary-blue: #D2DDF0;
      --gradient-201-secondary-blue: #D2DDF0;

      --gradient-100-light-secondary-blue: #E7EEF8;
      --gradient-101-light-secondary-blue: #E7EEF8;

      --gradient-050-light-blue: #F5F9FD;
      --gradient-051-light-blue: #F5F9FD;

      --gradient-010-very-light-blue: #FCFDFF;
      --gradient-011-very-light-blue: #FCFDFF;

      --grey-layout-chart-100: #0000001f;
      --red-chart-600: #D23138;
      --red-chart-400: #EF5350;
      --yellow-chart-050: #FFB74D;
      --green-chart-050: #00CC66;

      --green-teal-chart-400: #005850;
      --green-teal-chart-300: #00837B;
      --green-teal-chart-200: #00A19B;
      --green-teal-chart-100: #00BBB4;
      --green-teal-chart-050: #00CCBD;

      --teal-chart-400: #1B8AA8;
      --teal-chart-300: #2898B2;
      --teal-chart-200: #35A9BC;
      --teal-chart-100: #44BAC6;
      --teal-chart-050: #54CBD1;

      --blue-chart-500: #295CA5;
      --blue-chart-400: #366EB2;
      --blue-chart-300: #4480BC;
      --blue-chart-200: #5493C6;
      --blue-chart-100: #65A6D1;
      --blue-chart-050: #67B7DC;

      --sky-blue-chart-050: #019EE0;
      --indigo-blue-chart-050: #6771DC;
      --purple-chart-050: #A367DC;

      --focus-bg-color: #fff0;
      --background-transparent: #FFFFFF;

    /*--------------------------GZ-DATE-PICKER---------------------------------*/
      --gz-datepicker-hovered-cell-color: #D9E9FF;
    /*-------------------------VAADIN-GRID---------------------------------*/
      --reorder-ghost-background: #F2F2F2;
    /*--------------------------GZ-LOADER---------------------------------*/
      --gz-loader-background: #B3B3B3;
      --gz-loader-animation-bg: #E0E0E0;
    /*--------------------------GZ-PHONE-INPUT---------------------------------*/
      --gz-phone-input-border-color: #e0e0e0;
    }
  </style>

  ${darkColors}
  ${highContrast}
`;

document.head.prepend($_documentContainer);
